import {
  GET_BENEFITS_REQUEST,
  GET_BENEFITS_SUCCESS,
  GET_BENEFITS_FAILURE,
} from '../../api/Types';

const initialState = {
  collection: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFITS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BENEFITS_SUCCESS:
      return {
        collection: action.body,
        loading: false,
      };
    case GET_BENEFITS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
